import React, { memo } from 'react';

const SectionLabel = memo(({ color, title, hint }) => (
  <div className="col-span-12 flex items-center gap-2 -mb-2">
    <div className={`w-1 h-4 ${color} rounded-full`} />
    <span className="text-xs font-bold text-gray-600 uppercase tracking-wider">{title}</span>
    {hint && <span className="text-xs text-gray-400">— {hint}</span>}
  </div>
));

export default SectionLabel;
